/**
 *
 *  プロジェクト固有のユーティリティ関数を定義します
 *
 */

export const isCustomize = () => {
  return true;
};
